<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Set Moodlight" icon="🌈" color="#d97706">
        <label>State</label>
        <select :value="props.data.state !== false ? '1' : '0'" @change="update('state', $event.target.value === '1')">
            <option value="1">On</option>
            <option value="0">Off</option>
        </select>

        <label class="mt-1">Color</label>
        <div class="flex items-center gap-2">
            <input type="color"
                class="color-swatch"
                :value="hex"
                @input="onColorChange($event.target.value)" />
            <span class="font-mono text-[10px] text-gray-400 select-all">{{ hex }}</span>
        </div>

        <!-- numeric RGB read-out -->
        <div class="grid grid-cols-3 gap-1 mt-1 text-[10px] text-gray-500">
            <span>R {{ props.data.r ?? 255 }}</span>
            <span>G {{ props.data.g ?? 0 }}</span>
            <span>B {{ props.data.b ?? 0 }}</span>
        </div>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { computed } from 'vue';
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });

const hex = computed(() => {
    const toH = n => Math.round(Math.max(0, Math.min(255, n || 0))).toString(16).padStart(2, '0');
    return `#${toH(props.data.r ?? 255)}${toH(props.data.g ?? 0)}${toH(props.data.b ?? 0)}`;
});

function onColorChange(h) {
    const r = parseInt(h.slice(1, 3), 16);
    const g = parseInt(h.slice(3, 5), 16);
    const b = parseInt(h.slice(5, 7), 16);
    updateNodeData(props.id, { ...props.data, r, g, b });
}
</script>
